import axios from 'axios'
import projectUtil from '@/assets/scripts/project'
import {copy} from '@/assets/scripts/helper'
import {PROJECT_LIST, PROJECT_TREE} from '@/assets/scripts/api'
import {LOGIN} from '../../assets/scripts/api'
import item from '../../components/common/item/item'

const state = {
  rulePackageProsList: [],
  pricing_rules: [],
  changePrice: [],
  schemeClass: {},
  editProject: [],
  editData: [],
  currentClassGroupId: '',
  showProjectPrice: 0,
  dataKey: '',
  initBasePackagePros: [],
  recommendPackage: {},
  recommendProjects: [],
  recommendProjectList: [],
  recommendSubProjects: {},
  recommendSubProjectsAll: {}, //获取的所有互斥组
  checkedMaterialProjectList: [],
  checkedProjectList: [],
  projectTreeList: [],
  projectList: [],
  materialList: [],
  projectClassList: [],
  product: {},
  productRecommend: {},
  productSubRecommend: {},
  productProjects: {},
  isDelList: [],
  productMaterialProjectList: {},
  initProductMaterialProjectList: {},
  mutexProjectClass: {},
  checkedProjectListByGroup: [],
  revertProjectList: [],
  initRecommendProjects: [], //保存最原始的推荐项目属性
  myRecommendProject: [],
  mTransformList: {},
  projectMutexList: {}, //{互斥组id：{  项目id： 项目在改互斥组中的排他性 }}
  historyProject: [],
  deleteList: [],
  instanceId: ''
}

const mutations = {
  /**
   * 清除体检项目缓存
   * @param state
   */
  clearProjectData (state) {
    state.rulePackageProsList = []
    state.deleteList = [] //所有手动删除的项目
    state.historyProject = [] //所有选过的项目
    state.projectMutexList = {} //{互斥组id：{  项目id： 项目在改互斥组中的排他性 }}
    state.pricing_rules = []
    state.schemeClass = {}
    state.isDelList = []
    state.myRecommendProject = []
    state.recommendSubProjectsAll = {}
    state.mTransformList = {}
    state.editProject = []
    state.productSubRecommend = {}
    state.productRecommend = {}
    state.currentClassGroupId = ''
    state.showProjectPrice = 0
    state.dataKey = ''
    state.recommendPackage = {}
    state.recommendProjects = []
    state.recommendProjectList = []
    state.recommendSubProjects = {}
    state.checkedMaterialProjectList = []
    state.checkedProjectList = []
    state.projectTreeList = []
    state.projectList = []
    state.materialList = []
    state.productProjects = {}
    state.product = {}
    state.productMaterialProjectList = {}
    state.initProductMaterialProjectList = {}
    state.projectClassList = []
    state.mutexProjectClass = {}
    state.checkedProjectListByGroup = []
    state.revertProjectList = []
    state.initRecommendProjects = []
    state.instanceId = ''
  },
  setDeleteList (state, project) {
    let list = state.deleteList
    list = list.filter(item => {
      return !state.checkedProjectList.some(obj => {
        return obj.id === item.id
      })
    })
    if (id && list.some(obj => {
      return obj.id === project.id
    })) {
      list.push(project)
    }
    state.deleteList = list
  },
  setSchemeClass (state, data) {
    state.schemeClass = data
  },
  setmyRecommendProject (state, data) {
    state.myRecommendProject = data
  },
  setInitRecommendProjects (state, data) {
    state.initRecommendProjects = data
  },
  setRecommendSubProjectsAll (state, data) {
    state.recommendSubProjectsAll = data
  },
  setInstanceId (state, data) {
    state.instanceId = data
  },
  setEditProject (state, data) {
    state.editProject = data
  },
  setEditData (state, data) {
    state.editData = data
  },
  setDataKey (state, data) {
    state.dataKey = data
  },
  setProProjectData (state, data) {
    console.log(data, state.projectList)
    state.projectList.forEach(obj => {
      if (!data.some($item => {
        return $item.id === obj.id
      })) {
        obj.visible = 0
      }
    })
  },
  setProjectMutexList (state, data) {
    state.projectMutexList = projectUtil.getProjectMutexList(data)
  },
  setProjectListTree (state, data) {
    state.projectListTree = data
  },
  setPricingRules (state, data) {
    state.pricing_rules = data
  },
  setRulePackagePros (state, data) {
    let list = state.projectList
    let starList = []
    let rulePackageProsIdList = []
    let rulePackageProsList = []
    data.forEach((obj, index) => {
      if (obj.testMothodPro.basePackagePros) {
        starList = starList.concat(obj.testMothodPro.basePackagePros || [])
      }
      if (index === data.length - 1) {
        obj.testMothodPro.rulePackagePros.forEach(item => {
          rulePackageProsIdList.push(item.projectId)
          let isIndex = starList.findIndex($i => {
            return $i.projectId === item.projectId
          })
          if (isIndex > 0) {
            starList[isIndex].counditionInfoList = item.counditionInfoList
            starList[isIndex].star = item.star
          } else {
            starList.push(item)
          }
        })
      }
    })
    starList.forEach(project => {
      for (var i = 0; i < list.length; i++) {
        if (project.projectId === list[i].id) {
          list[i].star = project.star
          if (rulePackageProsIdList.includes(project.projectId)) {
            list[i].counditionInfoList = project.counditionInfoList || []
            list[i].coundtionInfoCode = true
            rulePackageProsList.push(list[i])
          }
          break
        }
      }
    })
    state.rulePackageProsList = rulePackageProsList
    state.projectList = list
  },
  /**
   *  设置缓存自选体检项目的条件
   * @param state
   * @param data
   */
  setProjectData (state, data) {
    state.showProjectPrice = (data.showPrice || 0).toString()
    state.projectClassList = data.projectClassList.filter((project) => {
      if (project.items && project.items.length > 0) {
        project.item = project.itemName
        project.parentItemId = ''
        return project
      } else {
        return false
      }
    })
    state.projectList = data.projectList.filter(obj => {
      return obj.typable === '0'
    })
    state.materialList = data.materialList.sort(function (a, b) {
      return ((a.orderNum < b.orderNum) ? -1 : ((a.orderNum > b.orderNum) ? 1 : 0))
    })
    // projectUtil.setMaterialListAll(state.materialList)
  },
  /**
   * 保存自选体检项目树状集合 ,用于分科室显示自选体检项目
   * @param state
   * @param data
   */
  setProjectTreeList (state, data) {
    let isTreeList = data
    // console.log(state.projectList, data)
    state.projectTreeList = projectUtil.replaceTree(state.projectList, isTreeList)
  },
  /**
   * 保存已选择体检项目
   * @param state
   * @param data
   */
  setCheckedProjectList (state, data) {
    state.checkedProjectList = data.sort(function (a, b) {
      return ((a.orderNum < b.orderNum) ? -1 : ((a.orderNum > b.orderNum) ? 1 : 0))
    })
  },
  checkProject (state, project) {

    let replacedList = (state.productProjects && state.productProjects.replaced && state.productProjects.replaced.projectList.length ? state.productProjects.replaced.projectList : [])
    if (project) {
      state.checkedProjectList = projectUtil.getCheckedProjectList(project, state.projectList, state.checkedProjectList, state.projectMutexList, state.materialList, replacedList)
      let historyProjectList = state.historyProject
      let deleteList = state.deleteList
      state.checkedProjectList.forEach(obj => {
        if (!historyProjectList.some(p => {
          return p.id === obj.id
        })) {
          historyProjectList.push(Object.assign({}, obj))
        }
      })
      state.historyProject = historyProjectList
      if (!state.checkedProjectList.some(obj => {
        return obj.id === project.id
      })) {
        deleteList.push(project)
        state.deleteList = deleteList
      }
    }
  },
  /**
   *  设置缓存自选体检项目的条件
   * @param state
   * @param data
   */
  setCurrentClassGroupId (state, data) {
    state.currentClassGroupId = data
  },
  /**
   * 保存已选择体检项目的关联项目
   * @param state
   */
  setCheckedMaterialProjectList (state) {
    let projectList = []
    if (state.product && Object.keys(state.product).length) {
      let isProductArr = []
      let result = JSON.parse(JSON.stringify(state.product.packageProjects.concat(state.product.packageProjectsForGift)))
      result = result.filter(obj => {
        return !state.mTransformList.list || state.mTransformList.list.indexOf(obj.id) === -1 || (state.materialList.find($obj => $obj.id === obj.projectId) && state.materialList.find($obj => $obj.id === obj.projectId).recalculate === 0)
      })
      if (state.productProjects && state.productProjects.replaced && state.productProjects.replaced.projectList.length) {
        result = result.filter(obj => {
          return !state.productProjects.replaced.projectList.some(item => {
            return item.id === obj.projectId
          })
        })
      }
      result.forEach(obj => {
        isProductArr.push(state.projectList.find(project => project.id === obj.projectId))
      })
      projectList = projectUtil.getMaterialProjectList(state.checkedProjectList, state.materialList, state.projectMutexList, isProductArr, result)
    } else {
      projectList = projectUtil.getMaterialProjectList(state.checkedProjectList, state.materialList, state.projectMutexList)
    }

    let materialProjectList = []
    for (let materialProject of projectList) {
      var isIn, index, isInProduct
      isIn = materialProjectList.some((p, i) => {
        if (p.id === materialProject.id) {
          index = i
          return p
        }
      })
      isInProduct = state.productMaterialProjectList[materialProject.id] > 0
      if (!isInProduct && state.productProjects && state.productProjects.packageProjectList) {
        let productList = JSON.parse(JSON.stringify(state.productProjects.packageProjectList))
        productList.forEach((obj, i) => {
          state.productProjects.replaced && state.productProjects.replaced.projectList && state.productProjects.replaced.projectList.forEach(item => {
            if (item.id === obj.id) {
              productList.splice(i, 1)
            }
          })
        })
        productList.forEach(obj => {
          projectUtil.getMaterialProjectList([obj], state.materialList, state.projectMutexList).forEach(item => {
            if (item.id === materialProject.id && item.recalculate === 0) {
              isInProduct = true
            }
          })
        })
      }
      if (isIn && materialProject.recalculate === 1) {
        materialProject.count++
        materialProjectList[index] = materialProject
      } else if ((materialProject.recalculate === 1 && isInProduct && !isIn) || (!isInProduct && !isIn) || (!isIn && materialProject.recalculate === 0)) {
        if (materialProject) {
          materialProject.count = 1
          materialProjectList.push(materialProject)
        }
      }
    }

    state.checkedMaterialProjectList = materialProjectList.sort(function (a, b) {
      return ((a.orderNum < b.orderNum) ? -1 : ((a.orderNum > b.orderNum) ? 1 : 0))
    })
  },
  async setProductProjects (state) {
    if (state.product && state.product.discountPriceTotal) {
      let priceTotal = (state.product && state.product.discountPriceTotal || 0).toString().movePoint(2)
      let projectList = []
      let replacedRelation = {}
      let beSubstitutedList = []
      let productMaterialProjectList = Object.assign({}, state.initProductMaterialProjectList)
      let count = state.product.discount && state.product.discount.toString().movePoint(-2) || 1
      let price = 0
      for (let project of state.checkedProjectList) {
        if (project.mutexId && project.hasOwnProperty('priceDifference')) {
          let mutexProjectList = projectUtil.getMutexProjectRelation(project, copy(state.projectList), state.projectMutexList)
          for (let p of mutexProjectList) {
            if (projectList.some(obj => {
              return obj.id === p.id
            })) {
              break
            }
            if (p.packable === 1 && replacedRelation.hasOwnProperty(project.id)) {
              replacedRelation[project.id].push(p.id)
            } else if (p.packable === 1 && !replacedRelation.hasOwnProperty(project.id)) {
              replacedRelation[project.id] = [p.id]
            }
            if (p.packable === 1 && !projectList.includes(p)) {
              projectList.push(p)
              // priceTotal -= (count * p.discountPrice.toString().movePoint(2))
              if (p.relationships) {
                let materialProjectList = []
                materialProjectList = projectUtil.getMaterialProjectList([p], state.materialList, state.projectMutexList)
                if (p.projectRelationshipDtoList && p.projectRelationshipDtoList.length) {
                  p.projectRelationshipDtoList.forEach(item => {
                    if (state.productProjects.packageProjectList.some(obj => {
                      return item.projectId.split(',').includes(obj.id) && obj.id !== p.id
                    })) {
                      materialProjectList = materialProjectList.filter(obj => {
                        return !item.relationshipId.split(',').some($t => {
                          return $t.split('*')[0] === obj.id
                        })
                      })
                    }
                  })
                }
                for (let mp of materialProjectList) {
                  //mp.id
                  state.mTransformList.tree.forEach(obj => {
                    if (!beSubstitutedList.includes(obj.id) && obj.childernList.some($t => {
                      return $t.id === mp.id
                    })) {
                      beSubstitutedList.push(obj.id)
                      replacedRelation[project.id].push(obj.id)
                    }
                  })
                  if (mp.recalculate.toString() === '1') {
                    // 检测当前套餐所包含的耗材数量是否已经被替换完
                    if (productMaterialProjectList[mp.id] > 0) {
                      productMaterialProjectList[mp.id]--
                      priceTotal -= (count * mp.price.toString().movePoint(2))
                    }
                  } else if (mp.recalculate.toString() === '0' && productMaterialProjectList[mp.id] > 0) {
                    // 如果套餐中耗材数量已经被替换完,则不再减去耗材价格
                    if (!state.productProjects.packageProjectList.some(obj => {
                      return obj.id !== p.id && obj.relationships && obj.relationships.split(',').includes(mp.id)
                    })) {
                      productMaterialProjectList[mp.id]--
                      priceTotal -= (count * mp.price.toString().movePoint(2))

                    }
                  } else {
                    let arr = state.productProjects.packageProjectList.filter(obj => {
                      return obj.id === mp.id && !projectList.includes(obj) && !state.productProjects.packageProjectList.some(obj => {
                        return obj.id !== p.id && obj.relationships && obj.relationships.split(',').includes(mp.id) && !state.productProjects.replaced.projectList.some($obj => {
                          return $obj.id === obj.id
                        })
                      })
                    })
                    console.log(arr)
                    arr.forEach(obj => {
                      if (!beSubstitutedList.includes(obj.id)) {
                        beSubstitutedList.push(obj.id)
                        replacedRelation[project.id].push(obj.id)
                      }
                      projectList.push(obj)
                      // priceTotal -= (count * obj.price.toString().movePoint(2))
                    })
                  }
                }
              }
            }
          }
        }
      }
      let packageProjects = {} // key : 子项id value： 最低折扣的项目{id: parentID , discount: 10.0， price:  180 }
      // console.log(state.product.packageProjects)
      let packageProjectsProjectList = {}
      let  selectList = []
      let  hasRuleList = []
      state.product.packageProjects.forEach(obj=>{
        if(projectList.some($obj=> obj.projectId === $obj.id)){
          hasRuleList.push(obj)
        } else {
          selectList.push(obj)
        }
      })
      selectList.forEach(obj => {
        if (obj.subList && obj.subList.length) {
          obj.subList.forEach($obj => {
            if($obj.recalculate === 0 && (!packageProjects.hasOwnProperty($obj.projectId) ||  packageProjects[$obj.projectId].price < $obj.discountPrice.toString().movePoint(1)) ){
              packageProjects[$obj.projectId] = {
                id: obj.id,
                price: $obj.discountPrice.toString().movePoint(1)
              }
            }
          })
        }
      })
      hasRuleList.forEach(obj => {
        if (obj.subList && obj.subList.length) {
          obj.subList.forEach($obj => {
            if($obj.recalculate === 0 && !packageProjects.hasOwnProperty($obj.projectId)  &&
              (!packageProjectsProjectList.hasOwnProperty($obj.projectId) || packageProjectsProjectList[$obj.projectId].price > $obj.discountPrice.toString().movePoint(1))){
              packageProjectsProjectList[$obj.projectId] = {
                id: obj.id,
                price: $obj.discountPrice.toString().movePoint(1)
              }
            }
          })
        }
      })
      hasRuleList.forEach(obj => {
          if (obj.subList && obj.subList.length) {

            // if(  obj.subList.every($item=>{return $item.recalculate === 0  && packageProjectsProjectList[$item.projectId].id === obj.id })){
            //   priceTotal -= obj.discountPrice.toString().movePoint(2)
            // }else {
              let reducePrice = 0
              obj.subList.forEach($obj => {
                if ($obj.recalculate === 0 && (!packageProjectsProjectList.hasOwnProperty($obj.projectId) || packageProjectsProjectList[$obj.projectId].id !== obj.id)) {
                  reducePrice += $obj.discountPrice.toString().movePoint(1)
                }
              })
              priceTotal -=  parseFloat((count * (obj.discountPrice.toString().movePoint(2) - reducePrice)).toFixed(2))
          } else {
            priceTotal -=  parseFloat((count * obj.discountPrice.toString().movePoint(2)).toFixed(2))
          }
      })

      state.productProjects.replacedRelation = replacedRelation
      state.productMaterialProjectList = productMaterialProjectList
      state.productProjects.replaced = {projectList}
      state.isDelList = projectList
      state.productProjects.priceTotal = priceTotal.toString().movePoint(-2)
    }
  },
  async setProjectPricingRules (state) {
    //   state.changePrice.forEach(item => {
    //     if (state.checkedProjectList.some(obj => obj.id === item.id)) {
    //       state.checkedProjectList.forEach(obj => {
    //         if (obj.id === item.id) {
    //           obj.price = item.price
    //         }
    //       })
    //     } else {
    //       state.projectList.forEach(obj => {
    //         if (obj.id === item.id) {
    //           obj.price = item.price
    //         }
    //       })
    //     }
    //   })
    //   let list = []
    //   if (state.product && state.product.discountPriceTotal) {
    //     //套餐
    //     let productList = state.productProjects.packageProjectList.filter(obj => {
    //       return !state.productProjects.replaced.projectList.some(item => {
    //         return item.id === obj.id
    //       })
    //     })
    //     list = productList
    //     console.log(productList)
    //   }
    //   list = list.concat(state.checkedProjectList.concat(state.checkedMaterialProjectList))
    //
    //   let hasRule = []
    //   list.forEach(obj => {
    //     state.pricing_rules.forEach(item => {
    //       if (item.id === obj.id) hasRule.push(JSON.parse(JSON.stringify(item)))
    //     })
    //   })
    //
    //   if (hasRule.length > 1) {
    //     let classProject = {}
    //     hasRule.forEach((obj, index) => {
    //       obj.subList.forEach($obj => {
    //         if ($obj.recalculate === 0 || $obj.recalculate === '0') {
    //           if (!classProject.hasOwnProperty($obj.projectId)) {
    //             classProject[$obj.projectId] = []
    //           }
    //           obj.isRulePrice = obj.price
    //           classProject[$obj.projectId].push(obj)
    //         }
    //       })
    //     })
    //
    //     let changePrice = []
    //     for (var key in classProject) {
    //       if (classProject[key].length > 1) {
    //         var iINDEX = 0
    //         for (var i = 0; i < classProject[key].length; i++) {
    //           var c_project = classProject[key][i].subList.find(obj => {
    //             return obj.projectId === key
    //           })
    //           if (i > 0) {
    //             var next_project = classProject[key][iINDEX].subList.find(obj => {
    //               return obj.projectId === key
    //             })
    //           }
    //           if (c_project.price < next_project) {
    //             iINDEX = i
    //           }
    //         }
    //         classProject[key].forEach((obj, index) => {
    //           if (index !== iINDEX) {
    //             obj.isRulePrice -= (classProject[key][index].subList.find(obj => {
    //               return obj.projectId === key
    //             }).price)
    //             if (!changePrice.some($obj => {
    //               return $obj.id === obj.id
    //             })) {
    //               changePrice.push(JSON.parse(JSON.stringify(obj)))
    //             }
    //           }
    //         })
    //       }
    //     }
    //     state.changePrice = changePrice
    //     // changePrice
    //     state.checkedProjectList.forEach(obj => {
    //       changePrice.forEach(item => {
    //         if (obj.id === item.id) {
    //           item.price = obj.price
    //           obj.price = item.isRulePrice
    //           console.log(obj)
    //         }
    //       })
    //     })
    //   } else {
    //     state.changePrice = []
    //   }
  },
  /**
   * 保存已选择的推荐体检方案
   * @param state
   * @param data
   */
  setRecommendPackage (state, data) {
    data.recommendProDtos = data.recommendProDtos.map((project, i) => {
      project.orderNum = i
      return project
    })
    state.recommendPackage = data
  },
  /**
   * 撤销体检项目
   * @param state
   */
  removeRevertProject (state) {
    return state.revertProjectList.shift()
  },
  /**
   * 添加待撤销体检项目
   * @param state
   * @param data
   */
  addRevertProject (state, data) {
    state.revertProjectList = state.revertProjectList.concat([data])
  },

  initRecommendProjects (state) {
    let parentProjectList = []
    let subProjects = {}
    let projectList = state.projectList.filter((project) => {
      if (project.recommendable === 1 && project.mutexId) {
        for (let mutexId of project.mutexId.split(',')) {
          if (!parentProjectList.includes(mutexId)) {
            parentProjectList.push(mutexId)
          }
        }
      }
      if (project.recommendable === 1 || project.base === 1) {
        return true
      }
    })
    if (parentProjectList.join(',')) {
      let removeProjectIds = []
      let subList
      parentProjectList = state.projectList.filter((project) => {
        if (project.typable === '1' && parentProjectList.includes(project.id)) {
          subList = projectList.filter(p => p.parentId === project.id)
          if (subList && subList.length > 0) {
            subProjects[project.id] = subList
            for (let p of subList) {
              if (!removeProjectIds.includes(p.id)) {
                removeProjectIds.push(p.id)
              }
            }
            return project
          }
          return false
        }
      })
      let result = []
      for (let pr of parentProjectList) {
        if (pr.typable === '1' && subProjects[pr.id].length === 1) {
          result = result.concat(subProjects[pr.id])
        } else if (subProjects[pr.id].length > 1) {
          result.push(pr)
        } else if (!result.includes(pr)) {
          result.push(pr)
        }
      }
      projectList = projectList.filter(p => !removeProjectIds.includes(p.id)).concat(result)
    }
    state.recommendProjects = projectList.sort(function (a, b) {
      return ((a.baseOrderNum < b.baseOrderNum) ? -1 : ((a.baseOrderNum > b.baseOrderNum) ? 1 : 0))
    })
    state.recommendSubProjects = subProjects
  },
  initRecommendPackages () {
    state.recommendProjectList = []
  },
  initProjectClassList (state) {
    state.projectClassList = state.projectClassList.map((projectClass) => {
      let pro
      let items = []
      projectClass.items.forEach(p => {
        for (let item of state.projectList) {
          if (item.id === p.projectId) {
            item.parentItemId = projectClass.id
            pro = copy(item)
            pro.stress = p.stress
            items.push(pro)
            break
          }
        }
      })
      let projectMutexList = []
      state.projectTreeList.forEach(directory => {
        if (directory.children) {
          projectMutexList = projectMutexList.concat(directory.children.filter(project => {
            return project.children && project.children.length
          }))
        }
      })
      let children = []
      projectMutexList.forEach(mutex => {
        let mutexList = []
        mutex.children.forEach(mutexProject => {
          items.forEach(project => {
            if (project.id === mutexProject.id) {
              project.parentItemId = projectClass.id
              mutexList.push(project)
            }
          })
        })
        let {id, inspectionSignificance, orderNum, parentId, parentName, typable} = mutex
        if (mutexList && mutexList.length > 1) {
          children.push({
            children: mutexList,
            item: projectClass.item,
            mutexItem: mutex.item.replace(/[0-9]+/, mutexList.length),
            typable: '1',
            id,
            inspectionSignificance,
            orderNum,
            parentId,
            parentName
          })
        }
      })
      items.forEach(project => {
        if (!children.length || !children.some(mutex => {
          return (!mutex.children && mutex.id === project.id) || (mutex.children && mutex.children.some(mutexProject => {
            return mutexProject.id === project.id
          }))
        })) {
          children.push(project)
        }
      })
      projectClass.items = children
      return projectClass
    }).sort(function (a, b) {
      return ((a.rowIndex < b.rowIndex) ? -1 : ((a.rowIndex > b.rowIndex) ? 1 : 0))
    })
    // console.log(state.projectClassList)
  },
  initCustomizeProjectList (state, {basePackagePros, rulePackagePros, recommendPros}) {
    state.initBasePackagePros = basePackagePros
    state.checkedProjectList = []
    state.projectList = state.projectList.filter((project) => {
      project.replaceable = '1'
      project.delectable = '1'
      if (!project.parentId) {
        project.parentId = ''
      }

      let baseProject = basePackagePros.find((p) => p.projectId === project.id)
      if (baseProject) {
        project.visible = 1
        project.base = 1
        project.delectable = (baseProject.delectable || '1').toString()
        project.replaceable = (baseProject.replaceable || '1').toString()
        state.checkedProjectList = projectUtil.getCheckedProjectList(project, state.projectList, state.checkedProjectList, state.projectMutexList, state.materialList, [])
      }
      let recommendProject = recommendPros.find((p) => p.projectId === project.id)
      if (recommendProject) {
        project.baseOrderNum = recommendProject.orderNum
        if (recommendProject.type === '0') project.base = 1
        project.recommendable = 1
      }
      return true
    })
    console.log(state.projectList)
    state.projectList = state.projectList.filter((project) => {
      if (rulePackagePros.some((p) => p.projectId === project.id)) {
        project.recommendable = 1
        state.checkedProjectList = projectUtil.getCheckedProjectList(project, state.projectList, state.checkedProjectList, state.projectMutexList, state.materialList, [])
        let historyProjectList = []
        state.checkedProjectList.forEach(obj => {
          historyProjectList.push(Object.assign({}, obj))
        })
        state.historyProject = historyProjectList
      }
      return true
    })
    state.historyProject = JSON.parse(JSON.stringify(state.checkedProjectList))
  },
  initPackageProjectList (state, packagePros) {
    state.checkedProjectList = []
    state.productProjects.packageProjectList = []
    let packageProjectList = state.product.packageProjects.concat(state.product.packageProjectsForGift)

    let transformList = []
    let transformationAfter = []
    state.product.partitionedProjects && state.product.partitionedProjects.forEach(obj => {
      let list = state.projectList.filter(project => {
        return project.id === obj.originalProjectId
      })
      if (list.length) {
        transformList.push(Object.assign({}, list[0], {childernList: obj.partitionProjects.split(',')}))
      }
    })

    packageProjectList.forEach(obj => {
      transformList.forEach($item => {
        if ($item.childernList.includes(obj.projectId)) {
          transformationAfter.push(obj.projectId)
          $item.childernList.splice($item.childernList.findIndex($obj => {
            return $obj === obj.projectId
          }), 1, Object.assign({}, obj))
        }
      })
    })
    state.mTransformList = {
      tree: transformList,
      list: transformationAfter
    }
    state.projectList = state.projectList.filter((project) => {
      project.replaceable = '1'
      project.delectable = '1'
      let packageProject = packageProjectList.find((p) => p.projectId === project.id)
      if (packageProject) {
        project.replaceable = packageProject.replaceable || '0'
        project.delectable = '0'
        project.visible = 1
        project.packable = 1
        project.discountPrice = packageProject.discountPrice
        state.productProjects.packageProjectList.push(project)

        if (project.replaceable === '1' && project.mutexId && typeof project.mutexId === 'string') {
          let mutexIds = project.mutexId.split(',') || []
          for (let id of mutexIds) {
            let projects = projectUtil.getTreeList(state.projectList, id, 'mutexId')
            for (let obj of projects) {
              if (obj.mutexId && project.id !== obj.id) {
                // 套餐所在互斥组非套餐项目都以补差价形式显示项目价格
                if (!obj.hasOwnProperty('priceDifference')) {
                  obj.priceDifference = {}
                }
                obj.priceDifference[id] = (obj.price.toString().movePoint(2) - project.discountPrice.toString().movePoint(2)).toString().movePoint(-2)
              }
            }
          }
        }
      }

      if (!project.parentId) {
        project.parentId = ''
      }
      return true
    })
    state.projectTreeList = projectUtil.getProjectTreeList(state.projectList)

    state.productMaterialProjectList = {}

    for (let m of packageProjectList.filter((material) => material.num > 0)) {
      for (let material of state.materialList) {
        if (material.id === m.id && m.num > 0) {
          material.num = m.num
          state.productMaterialProjectList[material.id] = material.num
          state.initProductMaterialProjectList[material.id] = material.num
          break
        }
      }
    }
  },
  initRecommendProjectList (state) {
    // let projectListAll = []
    // console.log(state.productRecommend)
    // state.productRecommend[0].testMothodPro.basePackagePros.forEach(obj => { projectListAll.push(obj.projectId) })
    // state.productRecommend[0].testMothodPro.rulePackagePros.forEach(obj => { projectListAll.push(obj.projectId) })
    // // state.productRecommend[1].testMothodPro.rulePackagePros.forEach(obj => { projectListAll.push(obj.projectId) })
    // let arr_1 = []
    // let arr_2 = []
    // let arr_3 = []
    // state.productRecommend[1].testMothodPro.rulePackagePros.forEach(obj => {
    //   if (!projectListAll.includes(obj.projectId)) {
    //     arr_1.push(obj)
    //     projectListAll.push(obj.projectId)
    //   }
    // })
    // state.productRecommend[1].testMothodPro.rulePackagePros = arr_1
    // state.productRecommend[2].testMothodPro.rulePackagePros.forEach(obj => {
    //   if (!projectListAll.includes(obj.projectId)) {
    //     arr_2.push(obj)
    //     projectListAll.push(obj.projectId)
    //   }
    // })
    // state.productRecommend[2].testMothodPro.rulePackagePros = arr_2
    // state.productRecommend[3].testMothodPro.rulePackagePros.forEach(obj => {
    //   if (!projectListAll.includes(obj.projectId)) {
    //     arr_3.push(obj)
    //     projectListAll.push(obj.projectId)
    //   }
    // })
    // state.productRecommend[3].testMothodPro.rulePackagePros = arr_3
    let projectRed = {
      thoroughRulePackagePros: {
        id: 'thoroughRulePackagePros',
        data: []
      },
      lastRulePackagePros: {
        id: 'lastRulePackagePros',
        data: []
      },
      basePackagePros: {
        id: 'basePackagePros',
        data: []
      },
      rulePackagePros: {
        id: 'rulePackagePros',
        data: []
      }
    }
    state.projectList.forEach((project) => {
      if (!project.coundtionInfoCode) {
        console.log(project, state.productRecommend)
        if (state.productRecommend[0].testMothodPro.basePackagePros.find((p) => p.projectId === project.id)) {
          projectRed.basePackagePros.data.push(project)
          project.recommendable = 1
        } else if (state.productRecommend[1].testMothodPro.basePackagePros.find((p) => p.projectId === project.id)) {
          projectRed.rulePackagePros.data.push(project)
          project.recommendable = 1
        } else if (state.productRecommend[2].testMothodPro.basePackagePros.find((p) => p.projectId === project.id)) {
          projectRed.lastRulePackagePros.data.push(project)
          project.recommendable = 1
        } else if (state.productRecommend[3].testMothodPro.basePackagePros.find((p) => p.projectId === project.id)) {
          projectRed.thoroughRulePackagePros.data.push(project)
          project.recommendable = 1
        }
      } else {
        project.recommendable = 1
      }
    })
    let dataKeyList = ['basePackagePros', 'rulePackagePros', 'lastRulePackagePros']
    dataKeyList.forEach(obj => {
      let parentProjectList = []
      let subProjects = {}
      let mutex = projectRed[obj].data.filter((project) => {
        if (project.mutexId) {
          for (let mutexId of project.mutexId.split(',')) {
            if (!parentProjectList.includes(mutexId)) {
              parentProjectList.push(mutexId)
            }
          }
        }
        return true
      })
      if (parentProjectList.join(',')) {
        let removeProjectIds = []
        let subList
        parentProjectList = state.projectList.filter((project) => {
          if (project.typable === '1' && parentProjectList.includes(project.id)) {
            subList = mutex.filter(p => p.parentId === project.id)
            if (subList && subList.length > 0) {
              subProjects[project.id] = subList
              for (let p of subList) {
                if (!removeProjectIds.includes(p.id)) {
                  removeProjectIds.push(p.id)
                }
              }
              return project
            }
            return false
          }
        })
        let result = []
        for (let pr of parentProjectList) {
          if (pr.typable === '1' && subProjects[pr.id].length === 1) {
            result = result.concat(subProjects[pr.id])
          } else if (subProjects[pr.id].length > 1) {
            result.push(pr)
          } else if (!result.includes(pr)) {
            result.push(pr)
          }
        }

        mutex = mutex.filter(p => {
          return !removeProjectIds.includes(p.id)
        })
      }
      for (let key in subProjects) {
        if (subProjects[key].length <= 1) {
          mutex = mutex.concat(subProjects[key])
          delete (subProjects[key])
        } else {
          state.projectList.forEach((project) => {
            if (key === project.id) mutex.push(project)
          })
        }
      }
      mutex = mutex.sort(function (a, b) {
        return ((a.orderNum < b.orderNum) ? -1 : ((a.orderNum > b.orderNum) ? 1 : 0))
      })
      state.productSubRecommend[obj] = subProjects
      projectRed[obj].data = mutex
    })
    state.productRecommend = projectRed
  },
  setProduct (state, data) {
    state.product = data
  },
  setProductRecommend (state, data) {
    state.productRecommend = data
  }
}

const getters = {
  /**
   *  获取已选择体检项目价格
   */
  priceInfo (state) {
    let checkedProjectPrice = 0
    let baseProjectPrice = 0
    let customProjectPrice = 0
    let materialProjectPrice = 0
    // state.pricing_rules
    let project_pricing_rules = {}
    if (state.product && state.product.packageProjects) {
      let replacedList = state.productProjects.replaced && state.productProjects.replaced.projectList || []
      state.product.packageProjects.forEach(obj => {
        if (obj.subList && obj.subList.length && !replacedList.some($t=>{return $t.id === obj.projectId})) {
          obj.subList.forEach(item => {
            if (item.recalculate === 0 && (!project_pricing_rules[item.projectId] || project_pricing_rules[item.projectId].price > item.discountPrice.toString().movePoint(-1))) {
              project_pricing_rules[item.projectId] = {
                id: obj.id, price: item.discountPrice.toString().movePoint(-1), code: 'product'
              }
            }
          })
        }
      })
      console.log(project_pricing_rules)
      // state.checkedProjectList.forEach(obj => {
      //   let isPricing_rules = {}
      //   if (obj.base === 1) {
      //     isPricing_rules = state.product.packageProjects.find($item => {
      //       return $item.projectId === obj.id
      //     })
      //   } else {
      //     isPricing_rules = state.pricing_rules.find($item => {
      //       return $item.id === obj.id
      //     })
      //   }
      //   console.log(isPricing_rules, obj.item)
      //   // if (Object.keys(isPricing_rules).length) {
      //     // if(obj.base === 1){ //套餐
      //     //   console.log()
      //     // }else {
      //     //
      //     // }
      //     // console.log(isPricing_rules)
      //   // }
      // })
    }
    state.checkedProjectList.forEach(obj => {

      let r = state.pricing_rules.find($obj => {
        return $obj.id === obj.id
      })
      if (r) {
        r.subList.forEach($obj => {
          if ($obj.recalculate === 0 && (!project_pricing_rules[$obj.projectId] || project_pricing_rules[$obj.projectId].price > $obj.discountPrice)) {
            project_pricing_rules[$obj.projectId] = {
              id: obj.id, price: $obj.discountPrice
            }
          }

        })
      }
    })
    for (let project of state.checkedProjectList || []) {
      let r = state.pricing_rules.find($obj => {
        return $obj.id === project.id
      })
      let reducePrice = 0
      if (r) {
        r.subList.forEach(obj => {
          if (obj.recalculate === 0 && project_pricing_rules[obj.projectId] && project_pricing_rules[obj.projectId].id !== project.id) {
            reducePrice += obj.discountPrice.toString().movePoint(2)
          }
        })
      }
      if (project.base === 1) {
        baseProjectPrice += (project.price || 0).toString().movePoint(2)
      } else {
        customProjectPrice += (project.price || 0).toString().movePoint(2)
      }
      checkedProjectPrice += (project.price || 0).toString().movePoint(2)
      if (r) {
        if (project.base === 1) baseProjectPrice -= reducePrice
        else customProjectPrice -= reducePrice
        checkedProjectPrice -= reducePrice
      }
    }

    for (let project of state.checkedMaterialProjectList || []) {
      let r = state.pricing_rules.find($obj => {
        return $obj.id === project.id
      })
      let reducePrice = 0
      if (r) {
        r.subList.forEach(obj => {
          if (obj.recalculate === 0 && project_pricing_rules[obj.projectId] && project_pricing_rules[obj.projectId].id !== project.id) {
            reducePrice += obj.discountPrice.toString().movePoint(2)
          }
        })
      }

      materialProjectPrice += ((project.price || 0).toString().movePoint(2) * (project.count || 1))
      if (r) {
        materialProjectPrice -= reducePrice
      }
    }
    let productProjectPrice = (state.productProjects.priceTotal || 0).toString().movePoint(2)
    return {
      baseProjectPrice: baseProjectPrice.toString().movePoint(-2),
      customProjectPrice: customProjectPrice.toString().movePoint(-2),
      checkedProjectPrice: checkedProjectPrice.toString().movePoint(-2),
      materialProjectPrice: materialProjectPrice.toString().movePoint(-2),
      priceTotal: (checkedProjectPrice + materialProjectPrice + productProjectPrice).toString().movePoint(-2)
    }
  },
  getReplacedProjects (state) {
    if (state.productProjects.replaced && state.productProjects.replaced.projectList) {
      let result = {}
      for (let data of state.productProjects.replaced.projectList) {
        result[data.id] = 1
      }
      return Object.keys(result)
    } else {
      return []
    }
  }
  ,
  getMaterialProjectList (state) {
    return state.checkedMaterialProjectList || []
  }
  ,

  /**
   * 获取体检套餐中的不重复计费的关联耗材
   * @param state
   */
  getproductMaterialProjectList (state, id) {
    if (state.productProjects && state.productProjects.packageProjectList) {
      let productList = JSON.parse(JSON.stringify(state.productProjects.packageProjectList))
      productList.forEach((obj, i) => {
        state.productProjects.replaced && state.productProjects.replaced.projectList && state.productProjects.replaced.projectList.forEach(item => {
          if (item.id === obj.id) {
            productList.splice(i, 1)
          }
        })
      })
    }
  }
  ,

  getBaseProjectList (state) {
    let base = state.checkedProjectList.filter((p) => p.base === 1)
    if (base && base.length > 1) {
      base = base.sort(function (a, b) {
        return ((a.baseOrderNum < b.baseOrderNum) ? -1 : ((a.baseOrderNum > b.baseOrderNum) ? 1 : 0))
      })
    }
    return base
  }
  ,
  getCustomProjectList (state) {
    return state.checkedProjectList.filter((p) => p.base !== 1) || []
  }
  ,
  getCheckedProjectListByClassGroup (state) {
    let classList = []
    let list = []
    console.log(state.checkedProjectList)
    for (let project of state.checkedProjectList.filter((p) => p.base !== 1) || []) {
      if (project.parentItemId) {
        console.log(project)
        classList.push(project.id)
      } else {
        list.push(project)
      }
    }
    let treeList = []
    let ids = [] //已进入组中的
    if (classList.length === 0) {
      return state.checkedProjectList.filter((p) => p.base !== 1) || []
    } else {
      let projectClassList = []
      state.projectClassList.forEach(dedicatedClass => { //所有的专病套餐
        let isClass = copy(dedicatedClass)
        console.log(isClass)
        let dedicatedProjectList = []
        // let counditionInfoList = []
        isClass.items.forEach(project => {
          if (project.children && project.children.length) {
            project.children.forEach(obj => {
              if (!dedicatedProjectList.some($p => {
                return $p.id === obj.id
              })) {
                dedicatedProjectList.push(obj)
              }
            })
          } else {
            if (!dedicatedProjectList.some($p => {
              return $p.id === project.id
            })) {
              dedicatedProjectList.push(project)
            }
          }
        })
        isClass.items = dedicatedProjectList
        projectClassList.push(isClass)
      })
      projectClassList.forEach(obj => {
        obj.typable = '1'
        obj.children = []
        classList.some(item => {
        })
        if (obj.items.some(project => {
          return classList.includes(project.id) && project.stress == '1'
        })) {
          obj.items.forEach(project => {
            if (classList.includes(project.id)) {
              obj.children.push(project)
              if (project.counditionInfoList && project.counditionInfoList.length) {
                if (!obj.counditionInfoList) {
                  obj.counditionInfoList = project.counditionInfoList
                } else {
                  project.counditionInfoList.forEach($p => {
                    if (!obj.counditionInfoList.some($item => {
                      return $item.id === $p.id
                    })) {
                      obj.counditionInfoList.push($p)
                    }
                  })
                }
              }
              ids.push(project.id)
            }
          })
        } else {
          obj.items.forEach(project => {
            if (classList.includes(project.id) && !ids.includes(project.id) && !list.some(item => {
              return item.id === project.id
            })) {
              list.push(project)
            }
          })
        }
      })
      list = list.filter(obj => {
        return !projectClassList.some(projectClass => {
          return projectClass.children && projectClass.children.some(project => {
            return project.id === obj.id
          })
        })
      })
      treeList = projectClassList.filter(obj => {
        return obj.children && obj.children.length
      }).concat(list).sort(function (a, b) {
        return ((a.orderNum < b.orderNum) ? -1 : ((a.orderNum > b.orderNum) ? 1 : 0))
      })
    }
    console.log(treeList)
    return treeList
  }
}
const actions = {
  /**
   * 根据用户信息获取可自选的体检项目数据
   * @param commit
   * @param state
   * @param params 年龄,性别,婚姻状况,体检中心ID
   * @returns {Promise<void>}
   */
  loadProjectData: async function ({commit, state}, params) {
    let {data} = await axios.get(PROJECT_LIST, {
      params: params
    })
    // commit('setDataKey', JSON.stringify(params))
    let {materialList, projectClassList, projectList, showPrice} = data
    commit('setProjectData', {materialList, projectClassList, projectList, showPrice})
    commit('setProjectListTree', data.projectListTree)

    let pricing_rules = await axios.get('/center-service/v1/project/pricing_rules/' + params.sysCenterId)
    commit('setPricingRules', pricing_rules.data)
  },
  loadProjectTree: async function ({commit, state}) {
    // let data = copy(state.projectListTree)
    commit('setProjectTreeList', state.projectListTree)
    commit('setProjectMutexList', state.projectListTree)
  },
  loadProductProjectData: async function ({commit, state}, params) {
    let {data} = await axios.get(PROJECT_LIST, {
      params: params
    })
    commit('setProProjectData', data.projectList)
  },
  /**
   * 记录已撤销的体检项目
   * @param commit
   * @param state
   * @param project 操作的体检项目对象
   */
  saveRevertProject ({commit, state}, project) {
    if (!state.revertProjectList.includes(project)) {
      commit('addRevertProject', project)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
